import { getCreditsHistoryByType } from './user';

/**
 * Check is a user has a specific event in credits history that corresponds to his current role
 *
 * @param {object} user - sdk user current or public
 * @param {string} eventToCheck - event name to check, see credits-config.js
 * @returns boolean
 */
export const checkIfCreditsEventExists = (user, eventToCheck) => {
    if (!user || !user.id) return false;

    const creditsByUserType = getCreditsHistoryByType(user);

    const creditsHistoryAvailable =
        Array.isArray(creditsByUserType) && creditsByUserType.length > 0 ? creditsByUserType : null;

    return creditsHistoryAvailable
        ? creditsHistoryAvailable.some(({ eventName }) => eventName === eventToCheck)
        : false;
};

export const checkIfCreditsEventRewarded = (user, eventToCheck) => {
    if (!user || !user.id) return false;

    const creditsByUserType = getCreditsHistoryByType(user);

    const creditsHistoryAvailable =
        Array.isArray(creditsByUserType) && creditsByUserType.length > 0 ? creditsByUserType : null;

    return creditsHistoryAvailable
        ? creditsHistoryAvailable.some(
              ({ eventName, rewardedAt }) => eventName === eventToCheck && rewardedAt
          )
        : false;
};
